import {
  getCalendarioFinanzasMensual,
  getCalendarioFinanzasMensualProduccion,
} from "../../API/Global/CalendarioFinanzas/CalendarioFinanzasRequest";
export const obtenerTasaCambioFinanzas = async (fecha) => {
  let d = new Date(fecha);
  let mes = d?.getMonth() + 1 > 1 ? d?.getMonth() + 1 : 1;
  let anio = d?.getFullYear();
  let tasaCambio = 0;

  const tempoCalendario = await getCalendarioFinanzasMensualProduccion();
  if (tempoCalendario?.length > 0) {
    let tempoTasaMes = tempoCalendario.find(
      (t) => t.NoMes === mes && t.Anio === anio,
    );

    if (tempoTasaMes) {
      if (tempoTasaMes?.TasaCambio > 0) {
        tasaCambio = tempoTasaMes?.TasaCambio;
      }
    }
  }

  return tasaCambio;
};

export const RedondearNumero = (value, digitos = 2) => {
  if (value) {
    let factor = Math.pow(10, digitos);
    let num = Math.round(value * factor) / factor;

    return Number(num?.toFixed(digitos));
  } else {
    return 0;
  }
};

export const obtenerNombreEmpresa = (fecha = new Date(), tipo) => {
  const fechaLimiteEmpresa = new Date(2026, 4, 7); // 7 de mayo de 2026 (mes es 0-indexado)
  const fechaLimiteZonaLibre = new Date(2026, 6, 7); // 7 de julio de 2026 (mes es 0-indexado)

  const fechaComparar = new Date(fecha);

  let empresa = {};

  // Determinar el nombre de la empresa
  if (fechaComparar >= fechaLimiteEmpresa) {
    empresa.NombreEmpresaMayuscula = "PRIME";
    empresa.NombreEmpresaMinuscula = "Prime";
  }else{
    empresa.NombreEmpresaMayuscula = "PRIDE";
    empresa.NombreEmpresaMinuscula = "Pride";
  }

  // Determinar el nombre de la zona libre
  if (fechaComparar >= fechaLimiteZonaLibre) {
    empresa.zonaLibreMayuscula = "PRIME";
    empresa.zonaLibreMinuscula = "Prime";
  } else {
    empresa.zonaLibreMayuscula = "PRIDE";
    empresa.zonaLibreMinuscula = "Pride";
  }

  return empresa;

};
